import { render, staticRenderFns } from "./ElementForecastPercentTableColumn.vue?vue&type=template&id=50dac0a5"
import script from "./ElementForecastPercentTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementForecastPercentTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementForecastPercentTableColumn.vue?vue&type=style&index=0&id=50dac0a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports